/**
 * AddAddonsCtrl controller
 */
import { CONTENT_TYPES_SETS_SHORT } from '../../app/core/constants'

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')
// controller mixins

AddAddonsCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * AddAddonsCtrl controller
 *
 * @class AddAddonsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddAddonsCtrl
 */
/* @ngInject */
export default function AddAddonsCtrl ($uibModal, $uibModalInstance, $location, $scope, Subscription, ChannelSet,
  ShowSet, VODSet, LiveEventSet, MultiSet, authSvc, type, assignedBasicSets, networkId, subscription, assignedAddons) {
  var vm = this
  vm.type = type

  vm.FEATURE_RADIO_CHANNELS_ENABLED = authSvc.hasEnabledFlag('FEATURE_RADIO_CHANNELS_ENABLED')

  vm.content_types_sets = CONTENT_TYPES_SETS_SHORT
  vm.subscription = subscription
  vm.subscriptionLengthDays = subscription.length * (subscription.lengthType === 'Months' ? 30 : 1)

  vm.contentSets = { assigned: { sets: [] }, available: { sets: [] } }

  vm.url = ''

  vm.availableFilter = ''
  vm.assignedFilter = ''
  vm.isFormDisabled = true

  vm.compareItemLength = function (cs) {
    if (vm.subscription.$periodType !== 'DUE_DATE' && cs.pricing.rent) {
      const { timeUnit, period } = cs.pricing.rent
      const itemLength = period * (timeUnit === 'MONTH' ? 30 : 1)
      return itemLength > vm.subscriptionLengthDays
    }
    return false
  }

  vm.setLongerSubscription = function (sets) {
    sets.forEach(set => { set.$longerSubscription = vm.compareItemLength(set) })
    return sets
  }

  vm.setLengthAsSubscription = function (sets) {
    if (type === 'channelSets') {
      sets.forEach(item => {
        if (!item.pricing.rent.rentLengthOverride) {
          item.pricing.rent.period = vm.subscription.length
          item.pricing.rent.timeUnit = vm.subscription.lengthType === 'Days' ? 'DAY' : 'MONTH'
        }
        item.$longerSubscription = vm.compareItemLength(item)
      })
    }
  }

  vm.longAddonsNames = ''

  vm.setLongAddonsNames = function () {
    vm.longAddonsNames = vm.longAddons.map(addon => addon.name).join(', ') + (vm.longAddons.length === 1 ? ' is ' : ' are ')
  }

  vm.longAddons = []

  vm.addToLongAddons = function (items) {
    vm.longAddons.push(...items.filter(set => set.$longerSubscription))
    vm.setLongAddonsNames()
  }
  vm.removeFormLongAddons = function (sets) {
    vm.longAddons = vm.longAddons.filter(addon => !sets.find(set => addon.id === set.id))
    vm.setLongAddonsNames()
  }

  vm.contentSets.assigned.sets = vm.setLongerSubscription(angular.copy(assignedAddons))
  vm.addToLongAddons(vm.contentSets.assigned.sets)

  /**
   * Table state for pageable request
   *
   * @memberof mwApp/packages.controller:AddAddonsCtrl
   */
  vm.initTableState = {
    page: 0,
    count: 25,
    name: '',
    last: false
  }

  switch (type) {
    case 'vodSets':
      vm.label = 'VOD'
      vm.url = '/vodsets/intersection'
      vm.Model = VODSet
      break
    case 'tvShowSets':
      vm.label = 'TV Show'
      vm.url = '/tv-show-sets/intersection'
      vm.Model = ShowSet
      break
    case 'channelSets':
      vm.label = 'Channel'
      vm.url = '/channelsets/intersection'
      vm.Model = ChannelSet
      break
    case 'liveEventSets':
      vm.label = 'Live Event'
      vm.url = '/live-event-sets/intersection'
      vm.Model = LiveEventSet
      break
    case 'multiSets':
      vm.label = 'Multi'
      vm.Model = MultiSet
      break
  }

  vm.getSets = function (isInit = true) {
    const params = { networkId, subscriptionId: subscription.id || 0 }
    const assigned = [...vm.contentSets.assigned.sets, ...assignedBasicSets]
    const available = vm.contentSets.available.sets

    if (isInit) {
      vm.tableState = { ...angular.copy(vm.initTableState), q: vm.availableFilter }
      available.length = 0
    } else {
      vm.tableState.page++
    }

    vm.Model.loadContentSets(params, vm.tableState)
      .then(result => {
        result.content.forEach(item => { item.$isSetFromAvailable = true })
        const toAvailable = result.content.filter(set => !assigned.find(s => s.id === set.id))
        vm.setLengthAsSubscription(toAvailable)
        available.push(...vm.setLongerSubscription(toAvailable))
        vm.tableState.last = result.last
        vm.needMoreSets()
      })
  }

  vm.needMoreSets = function () {
    if (!vm.tableState.last && vm.contentSets.available.sets.length < vm.tableState.count * 0.7) {
      vm.getSets(false)
    }
  }

  vm.getSets()

  /**
   * Handler for scroll event of Available select list
   *
   * @memberof mwApp/packages.controller:AddAddonsCtrl
   * @param event
   */
  vm.$timerScroll = 0
  vm.contentSetsCallbackScroll = (event) => {
    const isScrolled = event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6
    if (isScrolled && !vm.tableState.last) {
      window.clearTimeout(vm.$timerScroll)
      vm.$timerScroll = window.setTimeout(() => { vm.getSets(false) }, 700)
    }
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, event, type) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    if (type === 'available' && subscription.currency.id !== items[0].pricing.currency.id) {
      items.forEach(item => { item.selected = !item.selected })
      return true
    }
    list.sets = list.sets
      .slice(0, index)
      .concat(items)
      .concat(list.sets.slice(index))
    items.forEach(item => { item.selected = !item.selected })

    if (type === 'assigned') {
      vm.addToLongAddons(items)
    }
    if (type === 'available') {
      vm.removeFormLongAddons(items)
    }
    vm.isFormDisabled = false
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }
  /**
   * Delete show from showSet
   *
   * @memberof mwApp/packages.controller:AddAddonsCtrl
   */
  vm.deleteContentSet = function (set) {
    event.preventDefault()
    set.selected = false
    vm.contentSets.assigned.sets = vm.contentSets.assigned.sets.filter(s => s.id !== set.id)
    vm.removeFormLongAddons([set])
    if (subscription.currency.id === set.pricing.currency.id) {
      vm.contentSets.available.sets.push(set)
    }
    vm.isFormDisabled = false
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => { item.selected = false })
    list.dragging = false
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.sets = list.sets.filter(item => !item.selected)
    vm.needMoreSets()
  }

  /**
   * Method for filtering sets by name
   *
   * @param {Object} contentSet
   * @memberof mwApp/packages.controller:AddAddonsCtrl
   */
  vm.filteredAssigned = (contentSet) => {
    return vm.assignedFilter.length > 0
      ? contentSet.name.includes(vm.assignedFilter)
      : true
  }

  /**
   * Create or edit season, and close modal window afterwards
   *
   * @memberof mwApp/addContentSets.controller:AddAddonsCtrl
   */
  vm.submit = function () {
    const onSubmit = () => {
      vm.contentSets.assigned.sets.forEach(item => {
        item.pricing.currency = angular.copy(subscription.currency)
      })
      vm.setLengthAsSubscription(vm.longAddons)
      $uibModalInstance.close(vm.contentSets.assigned.sets.map(set => new vm.Model({ ...set, pricing: set.pricing })))
    }
    onSubmit()
  }

  $scope.$watch('vm.contentSets.assigned.sets', () => {
    vm.differentSets = vm.contentSets.assigned.sets.filter(set => set.pricing.currency.id !== subscription.currency.id)
  })

  vm.differentSetsNames = function () {
    return vm.differentSets.map(set => '-"' + set.name + '" is in currency ' + set.pricing.currency.name).join('</br>')
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/addContentSets.controller:AddAddonsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
